export default{
    "clinics.detail.cart.items.title"     : "Sélection d'articles",
    "clinics.detail.cart.items.mandatory" : "Articles obligatoires",
    "clinics.detail.cart.items.optional"  : "Articles optionnels",
    "clinics.detail.cart.items.selected"  : "Articles sélectionnés",
}